import API_BASE_URL, { looksLikeJwt, toAppPath } from './config';

const getAuthToken = () => {
  const token = localStorage.getItem('authToken');
  return looksLikeJwt(token) ? token.trim() : null;
};

/**
 * Authenticated API calls: HttpOnly cookie (set at login) + Bearer header when token is valid.
 * Do not put JWT in query strings (proxies/logs can corrupt them).
 */
export const authenticatedFetch = async (url, options = {}) => {
  const token = getAuthToken();
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(!isFormData && { 'Content-Type': 'application/json' }),
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers['X-Auth-Token'] = token;
  }

  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;

  const response = await fetch(fullUrl, {
    ...options,
    credentials: 'include',
    headers,
  });

  if (response.status === 401) {
    const currentPath = window.location.pathname;
    const onAuthPage =
      /\/login\/?$/.test(currentPath) ||
      /\/signup\/?$/.test(currentPath) ||
      /\/reset-password\/?$/.test(currentPath) ||
      currentPath.includes('super-admin-login') ||
      currentPath.includes('super-admin-signup') ||
      currentPath.includes('super-admin-forgot-password') ||
      currentPath.includes('super-admin-reset-password');

    if (!onAuthPage) {
      try {
        await fetch(`${API_BASE_URL}/api/auth/logout`, {
          method: 'POST',
          credentials: 'include',
        });
      } catch (_) {
        /* ignore */
      }
      localStorage.removeItem('authToken');
      localStorage.removeItem('adminUser');
      localStorage.removeItem('isAuthenticated');
      if (currentPath.includes('super-admin')) {
        window.location.href = toAppPath('/super-admin-login');
      } else {
        window.location.href = toAppPath('/login');
      }
    }
    return response;
  }

  if (response.status === 403) {
    console.error('[AUTH] 403 Forbidden - insufficient permissions');
  }

  return response;
};
